package com.macrofocus.eflux.ui

import js.objects.unsafeJso
import mui.material.Typography
import react.FC
import react.Props
import web.cssom.px

val HorizontalSpacer = FC<Props> {
    Typography {
        sx = unsafeJso {
            marginLeft = 10.px
            marginRight = 10.px
        }
        +""
    }
}